<template>
    <div class="liveChars" :id='id'></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'commonPie',
    props: ['id','data','radius','color','graphic','show', 'other', 'left','orient', 'reverse', 'i'],
    // id echase名称
    // data 数据的vaue 和 名称 @params{value：值,name:名字}
    // radius 图标的大小 [] 
    // color 图标颜色 [] 默认红蓝
    // graphic 文字的位置以及样式  默认为空
    // show legend的显示隐藏默认为隐藏
    // other: {top: 'legend的位置', center:'饼图的位置x，y，相当于grid'}
    mounted () {
        this.$nextTick(()=>{
            this.initCharts()
        })
    },
    watch: {
        i () {
            // this.$nextTick(()=>{
                this.initCharts()
            // })
        }
    },
    methods: {
        initCharts () {
            const myCharts = echarts.init(document.getElementById(this.id));
            const option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: this.show,
                    top: this.other ? this.other.top : '5%',
                    left: this.left ? this.left : 'center',
                    itemWidth: 13,
                    itemHeight: 13,
                    orient:this.orient? this.orient : 'horizontal',
                    data: this.reverse ?  this.data.reverse().map((item) => {
                        return item.name
                    }) :  this.data.map((item) => {
                        return item.name
                    })
                },
                graphic:this.graphic || [],
                series: [
                    {
                        type: 'pie',
                        radius: this.radius || ['45%', '60%'],
                        color:this.reverse ? this.color.reverse() || ['#548FEB','#E56262'] : this.color || ['#548FEB','#E56262'],
                        center:this.other ? this.other.center : ['50%','55%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                        },
                        labelLine: {
                            show: false
                        },
                        data:this.reverse ?  this.data.reverse() : this.data,
                        emptyCircleStyle: {
                            color: 'red'
                        }
                    }
                ]
            }
            myCharts.setOption(option)
        }
    }
}
</script>

<style lang="less">
.liveChars{
    width: 300px;
    height: 226px;
}
</style>